export const MAX_COLUMNS_PER_FORM_SECTION = 1;

export const MAX_COLUMNS_PER_SECTION_ROW = 12;
